import { render, staticRenderFns } from "./TypeBasePage.vue?vue&type=template&id=bcd7ae96&"
import script from "./TypeBasePage.vue?vue&type=script&lang=js&"
export * from "./TypeBasePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports